import { StepCard, StepView } from '../../components/view';
import { StepPreview } from '../../components/preview';

export const LiInMail = ({
  isOpen = false,
  step = {},
  onOpen = () => {},
  onClose = () => {},
  blueprint = {},
}) => {
  if (isOpen) {
    return <StepPreview step={step} onClose={onClose} blueprint={blueprint} />;
  }
  return <StepView blueprint={blueprint} step={step} onOpen={onOpen} />;
};

export const LiInMailView = (props) => {
  return (
    <StepCard {...props}>
      <LiInMail {...props} />
    </StepCard>
  );
};
